import React from 'react'
import '../../App.css'
import '../Motivation.css'


export default function ThankYou() {
    return <h1 className="donate-page">
        Thank You
    </h1>
}